import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

const state = {
  name: '',
  uuid: '',
  exportUsersDialog: false,
}
export default {
  actions,
  getters,
  state,
  mutations,
}



// WEBPACK FOOTER //
// ./src/vuex/modules/users/index.js